import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const openModal = (type: 'privacy' | 'terms', e: React.MouseEvent) => {
    e.preventDefault();
    setModalContent(type);
  };
  const closeModal = () => setModalContent(null);
  return <footer className="bg-black pt-20 pb-8 border-t border-white/10 relative z-10" data-id="element-227" data-mp="3ug3f7k7bqha9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228" data-mp="39904ifsbca6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-229" data-mp="36d3qyjl4vnu">
          {/* Logo Column */}
          <div data-id="element-230" data-mp="3qd6qrcv3rqye">
            <img src="https://cdn.magicpatterns.com/uploads/bD3v9AavBa4gaqpbXra7Xw/Logo_Jet_Foce.png" alt="JetForce Aerospace" className="h-12 object-contain mb-4" data-id="element-231" data-mp="3qcx8kbgauo39" />
            <p className="text-gold font-heading tracking-widest uppercase text-sm mb-6" data-id="element-232" data-mp="2ezbeqczhvybe">
              Your Cargo. Our Mission.
            </p>
            <div className="w-12 h-0.5 bg-gold/50 mb-6" data-id="element-233" data-mp="3lbdcst8dy9lt"></div>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-234" data-mp="3gbqxme8zyjad">
              Specialized aviation transportation and maintenance services
              keeping you airworthy, reliable, and ready to fly.
            </p>
          </div>

          {/* Services Column */}
          <div data-id="element-235" data-mp="828nw8tlg9aq">
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6" data-id="element-236" data-mp="81pghm1kl3ay">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-237" data-mp="31uo1e25c5ns">
              <li data-id="element-238" data-mp="hrs9vnclsj9t">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-239" data-mp="hsa8gqmqn9kw">
                  Aviation Cargo Transport
                </a>
              </li>
              <li data-id="element-240" data-mp="qrfboa98vr3e">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-241" data-mp="mrwm316haru8">
                  A&P Line Maintenance
                </a>
              </li>
              <li data-id="element-242" data-mp="yto8m0g0gbwb">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-243" data-mp="yv94puhz42wa">
                  100 Hour Inspections
                </a>
              </li>
              <li data-id="element-244" data-mp="18ksnl05orwr5">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-245" data-mp="18lbxpup3hgum">
                  Aircraft Interior Cleaning
                </a>
              </li>
              <li data-id="element-246" data-mp="1hmibhw0d0dk6">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-247" data-mp="1mk1uf9805eig">
                  Exterior Dry Wash
                </a>
              </li>
              <li data-id="element-248" data-mp="3obx0987kuosr">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-249" data-mp="3ocgiyr51xh7u">
                  AOG Emergency Support
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-250" data-mp="25o58ygmttnbm">
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6" data-id="element-251" data-mp="25nc8fxegnu1x">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-252" data-mp="21kpfft620335">
              <li data-id="element-253" data-mp="1worx5hb8cmnq">
                <a href="tel:+17862620064" className="hover:text-gold transition-colors" data-id="element-254" data-mp="1wpa4b8zfklaf">
                  +1 786-262-0064
                </a>
              </li>
              <li data-id="element-255" data-mp="2pa9yec27j0cf">
                <a href="mailto:dispatch@jetforceaviation.com" className="hover:text-gold transition-colors break-all" data-id="element-256" data-mp="2kdb4numggver">
                  dispatch@jetforceaviation.com
                </a>
              </li>
              <li data-id="element-257" data-mp="18zphgf05p3vv">
                <a href="mailto:operations@jetforceaviation.com" className="hover:text-gold transition-colors break-all" data-id="element-258" data-mp="18w1p3j6g6niq">
                  operations@jetforceaviation.com
                </a>
              </li>
              <li data-id="element-259" data-mp="2wnhjnqhsdm9e">
                <a href="https://jetforceaviation.com" className="hover:text-gold transition-colors" data-id="element-260" data-mp="2wnr28t0i4r52">
                  jetforceaviation.com
                </a>
              </li>
            </ul>
          </div>

          {/* Coverage Column */}
          <div data-id="element-261" data-mp="3bk8gbs02sjvb">
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6" data-id="element-262" data-mp="3bhm43f28pg6r">
              Coverage
            </h4>
            <p className="text-sm text-slate-400 leading-relaxed mb-4" data-id="element-263" data-mp="31m2ch4upl3nt">
              Serving MIA, FLL, MCO and all major US airports.
            </p>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-264" data-mp="36iss5r2lpx8p">
              International operations in Barranquilla, Cartagena, Medellin and
              El Salvador.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-265" data-mp="1nlg19r4p22vh">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-sm text-slate-500" data-id="element-266" data-mp="1ino0s8pzh8fo">
            <span data-id="element-267" data-mp="1wlkxr68cnguv">© 2025 JetForce Aerospace. All rights reserved.</span>
            <div className="flex gap-4" data-id="element-268" data-mp="1rnswhllteie0">
              <a href="#" onClick={e => openModal('privacy', e)} className="hover:text-white transition-colors" data-id="element-269" data-mp="1ro2m382y6nj6">
                Privacy Policy
              </a>
              <a href="#" onClick={e => openModal('terms', e)} className="hover:text-white transition-colors" data-id="element-270" data-mp="zuk1a6q341d5">
                Terms of Service
              </a>
            </div>
          </div>
          <div className="text-sm" data-id="element-271" data-mp="l66163k1yr0a">
            <span className="text-slate-500" data-id="element-272" data-mp="l5e7iya0n3cn">Website by </span>
            <span className="text-gold font-medium" data-id="element-273" data-mp="g7mcvwhzl34r">Eleven Studio</span>
          </div>
        </div>
      </div>

      {/* Modals */}
      <AnimatePresence data-id="element-274" data-mp="2g8j6dpqguy2m">
        {modalContent && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-275" data-mp="2l8oqmkuepiao">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={closeModal} data-id="element-276" data-mp="2q06src861ox8" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl bg-navy-light border border-gold/30 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh]" data-id="element-277" data-mp="22cp8e1r8dt4a">
              <div className="flex justify-between items-center p-6 border-b border-white/10 bg-navy" data-id="element-278" data-mp="172tpsdwzi43n">
                <h3 className="text-xl font-heading font-bold text-white uppercase" data-id="element-279" data-mp="12a0ok00q5dwb">
                  {modalContent === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
                </h3>
                <button onClick={closeModal} className="text-slate-400 hover:text-white transition-colors" data-id="element-280" data-mp="saru761y5x9f">
                  <X className="w-6 h-6" data-id="element-281" data-mp="jd7q7pcp9mv4" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto text-slate-300 text-sm space-y-4 custom-scrollbar" data-id="element-282" data-mp="edv79foy8zxt">
                {modalContent === 'privacy' ? <>
                    <p data-id="element-283" data-mp="28r4h58leqngl">
                      <strong data-id="element-284" data-mp="28quthrnu4se2">Last Updated: May 2025</strong>
                    </p>
                    <p data-id="element-285" data-mp="1hl8mb4877vw0">
                      JetForce Aerospace ("we," "our," or "us") is committed to
                      protecting your privacy. This Privacy Policy explains how
                      we collect, use, disclose, and safeguard your information
                      when you visit our website or use our services.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-286" data-mp="1ct7blmqoid83">
                      Information We Collect
                    </h4>
                    <p data-id="element-287" data-mp="12wm9pa9yhi8h">
                      We may collect personal information that you voluntarily
                      provide to us when you express an interest in obtaining
                      information about us or our products and services, when
                      you participate in activities on the Website, or otherwise
                      when you contact us. The personal information that we
                      collect depends on the context of your interactions with
                      us and the Website, the choices you make, and the products
                      and features you use.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-288" data-mp="7p3l4xyqru19">
                      How We Use Your Information
                    </h4>
                    <p data-id="element-289" data-mp="mehva8a56fhp">
                      We use personal information collected via our Website for
                      a variety of business purposes described below. We process
                      your personal information for these purposes in reliance
                      on our legitimate business interests, in order to enter
                      into or perform a contract with you, with your consent,
                      and/or for compliance with our legal obligations.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-290" data-mp="372m9qf1uno4m">Contact Us</h4>
                    <p data-id="element-291" data-mp="374qojs1ae7jo">
                      If you have questions or comments about this notice, you
                      may email us at dispatch@jetforceaviation.com.
                    </p>
                  </> : <>
                    <p data-id="element-292" data-mp="duciovxmtziv">
                      <strong data-id="element-293" data-mp="dx8fggxqui5q">Last Updated: May 2025</strong>
                    </p>
                    <p data-id="element-294" data-mp="8wkofv9im1bi">
                      These Terms of Service constitute a legally binding
                      agreement made between you, whether personally or on
                      behalf of an entity ("you") and JetForce Aerospace ("we,"
                      "us" or "our"), concerning your access to and use of the
                      website as well as any other media form, media channel,
                      mobile website or mobile application related, linked, or
                      otherwise connected thereto.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-295" data-mp="1kbhgzf4wr8nm">Services</h4>
                    <p data-id="element-296" data-mp="1fkhlmebfsyn8">
                      JetForce Aerospace provides specialized aviation
                      transportation, maintenance, and cleaning services. All
                      services are subject to availability and specific
                      contractual agreements entered into separately from this
                      website.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-297" data-mp="1wvwltdygl8pw">Liability</h4>
                    <p data-id="element-298" data-mp="21uhmtfljbwfe">
                      In no event will we or our directors, employees, or agents
                      be liable to you or any third party for any direct,
                      indirect, consequential, exemplary, incidental, special,
                      or punitive damages, including lost profit, lost revenue,
                      loss of data, or other damages arising from your use of
                      the site.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-299" data-mp="2pjac4t7nj611">Governing Law</h4>
                    <p data-id="element-300" data-mp="2uhc2lz7eq7mj">
                      These Terms shall be governed by and defined following the
                      laws of the State of Florida. JetForce Aerospace and
                      yourself irrevocably consent that the courts of Florida
                      shall have exclusive jurisdiction to resolve any dispute
                      which may arise in connection with these terms.
                    </p>
                  </>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </footer>;
}